export const UPDATE_ROUTES_NAVIGATE = 'UPDATE_ROUTES_NAVIGATE';
export const RESET_ROUTES_NAVIGATE = 'RESET_ROUTES_NAVIGATE';

export type TNewRoureStack = {
  path: string,
  scrollPos: number,
  option?: any,
}
